import { HTMLProps } from 'react';

type PillTint = 'green';

export const Pill: React.FC<HTMLProps<HTMLDivElement> & { tint: PillTint; isActive?: boolean }> = ({
    children,
    className,
    tint = 'green',
    isActive = false,
    ...rest
}) => {
    return (
        <div
            className={`px-3 py-1 rounded-full border border-bnd-green font-semibold cursor-pointer transition ${
                !!isActive
                    ? 'bg-bnd-green text-bnd-white-1'
                    : 'text-bnd-green dark:text-bnd-black-1 hover:bg-bnd-green hover:text-bnd-white-1 dark:hover:text-bnd-black-1'
            } ${className}`}
            // style={!!isActive ? {} : { backgroundColor: 'rgba(80, 175, 106, 0.1)' }}
            {...rest}
        >
            {children}
        </div>
    );
};
